import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Contacto`}</h2>
    <p>{`Si quieres contactarme para realizar alguna idea creativa, alguna propuesta comercial o te interesa tener alguna asesoría conmigo, puedes escribirme o encontrarme en alguna de estas plataformas: `}<a parentName="p" {...{
        "href": "https://www.linkedin.com/in/franco-rios-diaz/"
      }}>{`Linkedin`}</a>{` & `}<a parentName="p" {...{
        "href": "https://facebook.com/fullstackerpe"
      }}>{`Facebook`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      